export default __webpack_public_path__ + "static/media/Chaudhary-Mame-Khan.bc531872.mp3";